import React, { useContext, useEffect } from "react";
import { Layout, PageHeader, Row, Col, Card } from "antd";
import { useHistory } from "react-router-dom";
import boxYellow from "../../../assets/orders/inproccess-icon.svg";
import trackingGreen from "../../../assets/orders/order-success-icon.svg";
import trackingBlue from "../../../assets/orders/tracking-blue.svg";
import deliverdSVG from "../../../assets/user-point/icons/deliverd.svg";
import inStoreSVG from "../../../assets/user-point/icons/in-store.svg";
import cancelledSVG from "../../../assets/user-point/icons/cancelled.svg";
import UserPointContext from "../../context/user-point/userPointContext";
import UserPointLoading from "./UserPointLoading";

const { Content } = Layout;

const PointHome = () => {
  const userPointContext = useContext(UserPointContext);
  const { analysis, loading, getAnalysis } = userPointContext;

  useEffect(() => {
    getAnalysis();
  }, []);

  const history = useHistory();
  return (
    <>
      <Layout>
        {loading ? (
          <UserPointLoading />
        ) : (
          <Content className="webview-container">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Card style={{ borderRadius: "7px" }} bordered={false}>
                  <Row justify="space-around">
                    <Col xs={6}>
                      <strong
                        className="color_primary"
                        style={{
                          ...styles.verCenter,
                          ...styles.dashboardNumber
                        }}
                      >
                        {analysis.in_stock_orders}
                      </strong>
                    </Col>
                    <Col xs={4} className="marg-v-1">
                      <img
                        src={deliverdSVG}
                        width={dashboardIconWidth}
                        alt=""
                      />
                    </Col>
                    <Col className="marg-v-1">
                      <span
                        className="cd-content"
                        style={{ ...styles.verCenter }}
                      >
                        In Stock
                      </span>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Card style={{ borderRadius: "7px" }} bordered={false}>
                  <Row justify="space-around">
                    <Col xs={6}>
                      <strong
                        className="color_primary"
                        style={{
                          ...styles.verCenter,
                          ...styles.dashboardNumber
                        }}
                      >
                        {analysis.released_orders}
                      </strong>
                    </Col>

                    <Col xs={4} className="marg-v-1">
                      <img src={inStoreSVG} width={dashboardIconWidth} alt="" />
                    </Col>
                    <Col className="marg-v-1">
                      <span
                        className="cd-content"
                        style={{ ...styles.verCenter }}
                      >
                        Released
                      </span>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Card style={{ borderRadius: "7px" }} bordered={false}>
                  <Row justify="space-around">
                    <Col xs={6}>
                      <strong
                        className="color_primary"
                        style={{
                          ...styles.verCenter,
                          ...styles.dashboardNumber
                        }}
                      >
                        {analysis.received_orders}
                      </strong>
                    </Col>
                    <Col xs={4} className="marg-v-1">
                      <img
                        src={cancelledSVG}
                        width={dashboardIconWidth}
                        alt=""
                      />
                    </Col>

                    <Col className="marg-v-1">
                      <span
                        className="cd-content"
                        style={{ ...styles.verCenter }}
                      >
                        Collected
                      </span>
                    </Col>
                  </Row>
                </Card>
              </Col>

              {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Card style={{ borderRadius: "7px" }} bordered={false}>
                  <Row justify="space-around">
                    <strong
                      className="color_primary"
                      style={{ ...styles.verCenter, ...styles.dashboardNumber }}
                    >
                      {analysis.received_orders}
                    </strong>
                    <img src={onGoingSVG} width={dashboardIconWidth} alt="" />
                    <span
                      className="cd-content"
                      style={{ ...styles.verCenter }}
                    >
                      On Going
                    </span>
                  </Row>
                </Card>
              </Col> */}
            </Row>
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card
                  style={{ borderRadius: "7px", height: "100%" }}
                  bordered={false}
                  onClick={() => history.push("/release")}
                >
                  <Row justify="space-around">
                    <img src={trackingBlue} alt="" />
                    <h3 style={{ textAlign: "center", ...styles.verCenter }}>
                      <strong>Release Shipments</strong>
                    </h3>
                    <h4 style={{ textAlign: "center", ...styles.verCenter }}>
                      Browse {"&"} release
                    </h4>
                  </Row>
                </Card>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card
                  style={{ borderRadius: "7px", height: "100%" }}
                  bordered={false}
                  onClick={() => history.push("/recieve")}
                >
                  <Row justify="space-around">
                    <img src={trackingGreen} alt="" />
                    <h3 style={{ textAlign: "center", ...styles.verCenter }}>
                      <strong>Collect Shipments</strong>
                    </h3>
                    <h4 style={{ textAlign: "center", ...styles.verCenter }}>
                      Scan the QR-Code
                    </h4>
                  </Row>
                </Card>
              </Col>

              {/*<Col xs={24} sm={24} md={24} lg={24} xl={24}>*/}
              {/*  <Card*/}
              {/*      style={{ borderRadius: "7px", height: "100%" }}*/}
              {/*      bordered={false}*/}
              {/*      onClick={() => history.push("/received")}*/}
              {/*  >*/}
              {/*    <Row justify="space-around">*/}
              {/*      <img src={trackingGreen} alt="" />*/}
              {/*      <h3 style={{textAlign: "center", ...styles.verCenter}}>*/}
              {/*        <strong>Received Shipments</strong>*/}
              {/*      </h3>*/}
              {/*    </Row>*/}
              {/*  </Card>*/}
              {/*</Col>*/}
              {/*<Col xs={24} sm={24} md={24} lg={24} xl={24}>*/}
              {/*  <Card*/}
              {/*    style={{ borderRadius: "7px", height: "100%" }}*/}
              {/*    bordered={false}*/}
              {/*    onClick={() => history.push("/orders")}*/}
              {/*  >*/}
              {/*    <Row justify="space-around" align="center">*/}
              {/*      <img src={boxYellow} alt=""/>*/}
              {/*      <h3 style={{textAlign: "center", ...styles.verCenter}}>*/}
              {/*        <strong>All Orders</strong>*/}
              {/*      </h3>*/}
              {/*      <h4 style={{textAlign: "center", ...styles.verCenter}}>Browse all orders</h4>*/}
              {/*    </Row>*/}
              {/*  </Card>*/}
              {/*</Col>*/}
            </Row>
          </Content>
        )}
      </Layout>
    </>
  );
};
const styles = {};
styles.verCenter = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};

styles.dashboardNumber = {
  fontSize: "2rem",
  paddingTop: "10px"
};

const dashboardIconWidth = 30;

export default PointHome;
